import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_URL });

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('fmiq_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('fmiq_token');
      localStorage.removeItem('fmiq_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
